import React from 'react';

import { LanguageUtils } from "../language/LanguageUtils";

const Header: React.FC = () => {
    const handleChangeSelectLangauge =(event: { target: { value: string; }; }): void=>{
        LanguageUtils.setCookie(event.target.value);
        window.location.reload();
    }

    return (
        <header id="konami_hd">
            <div className="inner">
                <div className="konami_logo"><a href="https://www.konami.com/games/jp/ja/" rel="noopener noreferrer" target="_blank"><img src="../assets/img/hd_logo_konami.svg" alt="KONAMI" /></a></div>
            </div>

            <div className="switch-language">
            <select 
                    defaultValue={LanguageUtils.getCookie() as string}
                    onChange={handleChangeSelectLangauge}
                >
                    <option value="ja">日本語</option>
                    <option value="en">English</option>
                </select>
            </div>
        </header>
    );
};

export default Header;